import { createElement } from 'react'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { allAthletesFavorite } from './components/favoriteButton'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Surname',
    accessor: 'surname',
  },
  {
    Header: 'Nationality',
    accessor: 'nationality',
    minWidth: 130,
    width: 130,
  },
  {
    Header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Date Of Birth',
    accessor: 'dateOfBirth',
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(allAthletesFavorite, { ...props }),
  },
]
